export default {
    desktop: 1920,
    wrapperDesktop: 1464,
    laptop: 1200,
    tablet: 1000,
    intermediateTablet: 800,
    largeMobile: 600,
    mobile: 480,
    smallMobile: 400,
    uberSmallMobile: 360,
}
